import { colors } from '~/@common/styles'

export const VerticalDivider = `<span style="display: inline-block; width: 1px; height: 10px; background-color: ${colors.gray.$500}; margin: 0 6px;"></span>`
